export const DialogWidth = {
  Simple: '400px',
  SimpleWide: '600px',
  StandardNarrow: '70vw',
  Standard: '80vw',
  StandardWide: '90vw'
}
